export function modifyPdtData(packages) {
  return packages.map(packageItem => {
    const packageVariantDetails = {
      package_variant_details_list:
        packageItem?.listingPackageVariantsDetails?.packageVariants?.map(variant => ({
          unique_id: variant?.uniqueId,
          is_parent: variant?.isParent,
        })) || [],
    };

    const pricePersuasion =
      packageItem?.listingPricingDetails?.pricePersuasion?.map(p => p?.text).join('') || null;
    const urgencyPersuasion =
      packageItem?.listingPricingDetails?.urgencyPersuasion?.[0]?.info
        ?.map(i => i?.text)
        .join('') || null;
    const otherPromo =
      packageItem?.listingPricingDetails?.otherPromo?.[0]?.info?.map(i => i?.text).join('') || null;

    const tags =
      packageItem?.tags?.map(tag => ({
        type: tag?.type,
        values: tag?.type,
      })) || [];

    return {
      id: packageItem?.id,
      name: packageItem?.name,
      type: packageItem?.packageType,
      branch: packageItem?.branch,
      package_variant_details: packageVariantDetails,
      price: {
        price_key: packageItem?.listingPricingDetails?.priceKey,
        price_persuasion: pricePersuasion,
        urgency_persuasion: urgencyPersuasion,
        other_promo: otherPromo,
      },
      tags,
    };
  });
}

export function modifySectionForPDT(section) {
  return {
    id: section?.id || '',
    name: section?.name || '',
    type: section?.type || '',
    section_code: section?.sectionCode || '',
    position: {
      v: section?.order || '',
    },
  };
}
